module.exports = __webpack_public_path__ + "static/media/msnstart_110.14e13524.ico";